import styled from 'styled-components';
import { blackPearl_2, bigStone } from '@paradigm/design-system/src/colors';

const ActionsBar = styled.div`
  display: flex;
  align-items: center;
  justify-content: start;
  height: 43px;
  padding: 0 16px;
  background-color: ${blackPearl_2};
  border-bottom: solid 1px ${bigStone};

  button {
    &:focus-visible,
    &:focus {
      outline: none;
    }
  }
`;

export default ActionsBar;
